import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
const AssetDepreciations = ({ assetDepreciations, onRefresh }) => {
  const { reload, companyProfile } = useGlobalData();

  useEffect(() => {}, [reload]);

  return (
    <React.Fragment>
      {assetDepreciations.length ? (
        <React.Fragment>
          <CustomDataTable
            data={assetDepreciations}
            onRefreshData={() => {
              onRefresh();
            }}
            columns={[
              {
                header: "Asset Depreciation ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Fiscal Period",
                field: "fiscalPeriod",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Fiscal Year",
                field: "fiscalYear",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Unit Depreciation Amount",
                field: "unitDepAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.unitDepAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {companyProfile.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            guidance="You don't have any Asset Depreciations for this asset yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default AssetDepreciations;
